import type { Content } from '@/services/isomorphic/ContentService';
import type { MaybePromise } from '@/type-utils';
import { use, type FC } from 'react';
import { RenderContent } from '../Content/RenderContent';

export interface IContentProps {
  /**
   * Content to render.
   */
  content: MaybePromise<Content>;
  /**
   * Optional callback for handling when links are clicked.
   */
  handleLinkClick?: () => void;
}

/**
 * A component that abstracts over content rendering. It takes in content and renders
 * it as is.
 */
export const DirectContent: FC<IContentProps> = ({
  content,
  handleLinkClick
}) => {
  const resolvedContent = content instanceof Promise ? use(content) : content;

  return (
    <RenderContent
      handleLinkClick={handleLinkClick}
      content={resolvedContent}
    />
  );
};

export default DirectContent;
